/* eslint-disable consistent-return */
import { useCallback, useEffect, useState } from 'react';
import { Button, Box } from '@mui/material';
import { AccessAlarm } from '@mui/icons-material';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';

import {
  ContainerAuthentication,
  TitleAuthentication,
  TextAuthentication,
  TextCode,
  CountDown,
  TextCountDown,
} from './styles';

import { Authentication } from '../Authentication';

import {
  Company,
  validateCode,
  setUserLocalStorage,
  setTokensLocalStorage,
  resendCode,
} from '../../../../services';
import api from '../../../../services/api';

import { AuthOtp } from '../../types/AuthOtp';
import { AuthSectionSteps } from '../../types/AuthSectionSteps';

import useAuthStore from '../../../../store/auth';
import useCompanyStore from '../../../../store/companies';

import { useAuth } from '../../hooks/useAuth';

interface StepMfaProps {
  setIsLoading: (status: boolean) => void;
  setStepLogin: (step: AuthSectionSteps) => void;
}

export const StepMfa = ({
  setIsLoading,

  setStepLogin,
}: StepMfaProps) => {
  const { handleRedirect } = useAuth();

  const { user: userAuth } = useAuthStore(state => state);
  const { setCompanies } = useCompanyStore(state => state);

  const [totalTimeInSeconds, setTotalTimeInSeconds] = useState<any>(2);
  const [codeForAuthentication, setCodeForAuthentication] = useState<AuthOtp>({
    otp: '',
  });

  const formValidation = useCallback(() => {
    return Yup.object().shape({
      email: Yup.string()
        .email('Digite um e-mail válido')
        .required('O campo E-mail é obrigatório.'),
    });
  }, []);

  const { handleSubmit } = useForm({
    resolver: yupResolver(formValidation()),
  });

  const handleValidateCode = useCallback(async () => {
    try {
      setIsLoading(true);

      const response = await validateCode(
        userAuth?.email as string,
        codeForAuthentication?.otp,
      );

      if (response?.status === 200) {
        const { user, access_token, refresh_token, companies } = response.data;
        api().defaults.headers.common.Authorization = `Bearer ${access_token}`;

        const companiesActives = companies?.filter((c: Company) => c.status);

        const tokens = {
          access_token,
          refresh_token,
        };

        setUserLocalStorage(user);
        // setUserLocal(user);
        setTokensLocalStorage(tokens);
        // setUserExists(true);
        if (user?.profile) {
          if (companiesActives?.length === 0) {
            return setStepLogin(AuthSectionSteps.NO_LINKED_COMPANIES);
          }
          setCompanies([...companiesActives]);

          handleRedirect(user, companiesActives, setIsLoading, setStepLogin);
        }
        // setStepLogin('redirect');
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  }, [
    setIsLoading,
    codeForAuthentication?.otp,
    handleRedirect,
    setCompanies,
    userAuth?.email,
    setStepLogin,
  ]);

  const getTimeToResend = useCallback((): string => {
    const minutes = Math.floor(totalTimeInSeconds / 60);
    const seconds = totalTimeInSeconds % 60;
    return `0${minutes?.toFixed(0)}: ${
      seconds >= 10 ? seconds : `0${seconds}`
    }`;
  }, [totalTimeInSeconds]);

  useEffect(() => {
    if (totalTimeInSeconds === 0) {
      setTotalTimeInSeconds(0);
    } else {
      setTimeout(() => {
        setTotalTimeInSeconds(totalTimeInSeconds - 1);
      }, 1000);
    }
  }, [totalTimeInSeconds]);

  async function handleResendCode() {
    if (userAuth?.email) {
      try {
        setIsLoading(true);

        const response = await resendCode(userAuth?.email as string);

        if (response?.status === 200) {
          setTotalTimeInSeconds(60 * 5);
        }
      } catch (err) {
        console.log(err);
      } finally {
        setIsLoading(false);
      }
    }
  }

  return (
    <ContainerAuthentication>
      <TitleAuthentication>Código de autenticação enviado!</TitleAuthentication>
      <TextAuthentication sx={{ textAlign: 'center', marginBottom: '15px' }}>
        Enviamos um código de autenticação para o e-mail{' '}
        <b>{userAuth?.email}</b>.
      </TextAuthentication>
      <TextAuthentication sx={{ textAlign: 'center' }}>
        Caso não encontre em sua caixa de entrada, verifique no spam.
      </TextAuthentication>
      <TextCode>Digite o código que recebeu:</TextCode>
      <form onSubmit={handleSubmit(handleValidateCode)}>
        <Authentication
          codeForAuthentication={codeForAuthentication}
          setCodeForAuthentication={setCodeForAuthentication}
        />
        <Button
          variant="contained"
          onClick={handleValidateCode}
          sx={{
            width: '100%',
            height: '56px',
            fontSize: '15px',
            fontWeight: '500',
          }}
        >
          Validar código
        </Button>
      </form>
      {totalTimeInSeconds && totalTimeInSeconds > 0 ? (
        <CountDown>
          <TextCountDown>Você poderá reenviar em:</TextCountDown>
          <Box display="flex" alignItems="center" gap="5px">
            <AccessAlarm sx={{ width: '30px', height: '30px' }} />
            {getTimeToResend()}
          </Box>
        </CountDown>
      ) : (
        <Button
          onClick={() => handleResendCode()}
          sx={{
            marginTop: '20px',
            textDecorationLine: 'underline',
            textTransform: 'none',
            fontSize: '16px',
            padding: '0',
          }}
        >
          Reenviar código
        </Button>
      )}
    </ContainerAuthentication>
  );
};
